import { combineReducers } from 'redux';

import { CustomerDetailReducerState, customerDetailReducer } from '../customer-detail/store/customer-detail-reducer';
import { CustomerListReducerState, customerListReducer } from '../customer-list/store/customer-list-reducer';

export interface CustomersReducerState {
    customerList: CustomerListReducerState;
    customerDetail: CustomerDetailReducerState;
}

export const customersReducer = combineReducers<CustomersReducerState>({
    customerList: customerListReducer,
    customerDetail: customerDetailReducer,
});
